// French UI labels — STUB, flagged for translation.
// Empty by design: falls back to English (en.js) per key. Human translation
// only — no machine guesses. Copy the key structure from en.js, translate,
// then flip `translated: true` in i18n/languages.js. French also runs longer
// than English; mobile cards are built to wrap, not clip.
export default {}
